var _metadata, _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 178,
    height: 195.94,
    viewBox: "0 0 178 195.938",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, /*#__PURE__*/React.createElement("xXmpmeta", {
    xXmptk: "Adobe XMP Core 5.6-c142 79.160924, 2017/07/13-01:06:39",
    xmlnsX: "adobe:ns:meta/"
  }, /*#__PURE__*/React.createElement("rdfRDF", {
    xmlnsRdf: "http://www.w3.org/1999/02/22-rdf-syntax-ns#"
  }, /*#__PURE__*/React.createElement("rdfDescription", {
    rdfAbout: ""
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1 {        fill: #f92539;      }      .cls-1, .cls-2 {        fill-rule: evenodd;      }      .cls-2 {        fill: #fff;      }"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    transform: "translate(-274 -538)",
    d: "m438.16 695.27c7.615-4.394 13.845-15.172 13.845-23.959v-70.722c0-8.785-6.23-19.565-13.845-23.958l-61.307-35.36c-7.615-4.393-20.076-4.393-27.692 0l-61.306 35.36c-7.616 4.393-13.846 15.173-13.846 23.958v70.722c0 8.787 6.23 19.565 13.846 23.959l61.306 35.361c7.616 4.392 20.077 4.392 27.692 0z",
    "data-name": "Shape 1 copy 2 kopie copy 26"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    transform: "translate(-274 -538)",
    d: "M356.569,675.569a9.874,9.874,0,0,0,4.434-7.7V645.126a9.874,9.874,0,0,0-4.434-7.7l-19.632-11.369a9.812,9.812,0,0,0-8.868,0l-19.631,11.369a9.874,9.874,0,0,0-4.434,7.7v22.739a9.874,9.874,0,0,0,4.434,7.7l19.631,11.369a9.812,9.812,0,0,0,8.868,0Zm31-55a9.874,9.874,0,0,0,4.434-7.7V590.126a9.874,9.874,0,0,0-4.434-7.7l-19.632-11.369a9.812,9.812,0,0,0-8.868,0l-19.631,11.369a9.874,9.874,0,0,0-4.434,7.7v22.739a9.874,9.874,0,0,0,4.434,7.7l19.631,11.369a9.812,9.812,0,0,0,8.868,0Zm31,55a9.874,9.874,0,0,0,4.434-7.7V645.126a9.874,9.874,0,0,0-4.434-7.7l-19.632-11.369a9.812,9.812,0,0,0-8.868,0l-19.631,11.369a9.874,9.874,0,0,0-4.434,7.7v22.739a9.874,9.874,0,0,0,4.434,7.7l19.631,11.369a9.812,9.812,0,0,0,8.868,0Z",
    "data-name": "Shape 1 copy 2 kopie copy 29"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader);
export default __webpack_public_path__ + "static/media/loader.8dc9e2ff93ba9c6027eea8ec07ddceb9.svg";
export { ForwardRef as ReactComponent };